if (!window.__mpjJsLoaded) {
  window.__mpjJsLoaded = true;

  /* ---------------- Reveal on scroll ---------------- */
  (function () {
    var els = document.querySelectorAll(".mpj-rv");
    if (!els.length) return;
    function revealAll() {
      els.forEach(function (el) { el.classList.add("is-in"); });
    }
    if (!("IntersectionObserver" in window)) {
      revealAll();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
    /* Safety net: guarantee visibility even if the observer never fires
       (extensions, older WebViews, edge cases) — content must never stay hidden. */
    setTimeout(revealAll, 700);
  })();

  /* ---------------- Before/after slider ---------------- */
  (function () {
    document.querySelectorAll("[data-mpj-ba]").forEach(function (root) {
      var wrap = root.querySelector("[data-mpj-ba-afterwrap]");
      var handle = root.querySelector("[data-mpj-ba-handle]");
      if (!wrap || !handle) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.clipPath = "inset(0 0 0 " + pct + "%)";
        handle.style.left = pct + "%";
      }

      var dragging = false;

      function pctFromClientX(clientX) {
        var rect = root.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onMove(clientX) {
        setPos(pctFromClientX(clientX));
      }

      root.addEventListener("pointerdown", function (e) {
        dragging = true;
        root.setPointerCapture(e.pointerId);
        onMove(e.clientX);
      });
      root.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        onMove(e.clientX);
      });
      root.addEventListener("pointerup", function () { dragging = false; });
      root.addEventListener("pointercancel", function () { dragging = false; });

      handle.setAttribute("tabindex", "0");
      handle.setAttribute("role", "slider");
      handle.setAttribute("aria-label", "Curseur avant / après");
      handle.setAttribute("aria-valuemin", "0");
      handle.setAttribute("aria-valuemax", "100");
      handle.setAttribute("aria-valuenow", "50");

      handle.addEventListener("keydown", function (e) {
        var current = parseFloat(handle.style.left) || 50;
        if (e.key === "ArrowLeft") { setPos(current - 5); e.preventDefault(); }
        if (e.key === "ArrowRight") { setPos(current + 5); e.preventDefault(); }
        handle.setAttribute("aria-valuenow", String(Math.round(parseFloat(handle.style.left) || 50)));
      });

      setPos(50);

      if (window.mpjTrack) {
        var tracked = false;
        root.addEventListener("pointerdown", function () {
          if (!tracked) { tracked = true; window.mpjTrack("before_after_interaction", {}); }
        });
      }
    });
  })();

  /* ---------------- Wizard (funnel /commencer) ---------------- */
  (function () {
    var forms = document.querySelectorAll("[data-mpj-wizard]");
    forms.forEach(function (form) {
      var steps = form.querySelectorAll("[data-mpj-step]");
      var current = 0;

      function required(step) {
        return step.querySelectorAll("[data-mpj-required]");
      }

      function validateStep(step) {
        var ok = true;
        required(step).forEach(function (field) {
          var group = field.closest("[data-mpj-required-group]");
          var filled;
          if (field.type === "radio" || field.type === "checkbox") {
            var name = field.name;
            filled = !!form.querySelector('[name="' + name + '"]:checked');
          } else {
            filled = field.value && field.value.trim() !== "";
          }
          var err = (group || field.closest(".mpj-field"))?.querySelector(".mpj-error");
          if (!filled) {
            ok = false;
            if (err) { err.textContent = "Ce champ est requis."; err.classList.add("mpj-error--visible"); }
          } else if (err) {
            err.textContent = ""; err.classList.remove("mpj-error--visible");
          }
        });
        return ok;
      }

      function updateProgress() {
        var label = form.querySelector("[data-mpj-progress-label]");
        var fill = form.querySelector("[data-mpj-progress-fill]");
        if (label) label.textContent = (current + 1) + " / " + steps.length;
        if (fill) fill.style.width = (((current + 1) / steps.length) * 100) + "%";
      }

      function show(index) {
        steps.forEach(function (s, i) { s.classList.toggle("is-active", i === index); });
        current = index;
        updateProgress();
        window.scrollTo({ top: form.offsetTop - 40, behavior: "smooth" });
        if (window.mpjTrack) {
          window.mpjTrack("project_form_step_" + (index + 1), {});
        }
      }

      form.querySelectorAll("[data-mpj-next]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (!validateStep(steps[current])) return;
          if (current < steps.length - 1) show(current + 1);
        });
      });
      form.querySelectorAll("[data-mpj-prev]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (current > 0) show(current - 1);
        });
      });

      /* Recap on last step */
      var recapPackage = form.querySelector("[data-mpj-recap-package]");
      var recapType = form.querySelector("[data-mpj-recap-type]");
      var recapPhotos = form.querySelector("[data-mpj-recap-photos]");
      form.addEventListener("change", function () {
        if (recapType) {
          var t = form.querySelector('[name="properties[outdoor_type]"]:checked');
          recapType.textContent = t ? t.value : "—";
        }
        if (recapPackage) {
          var p = form.querySelector('[name="properties[selected_package]"]:checked');
          recapPackage.textContent = p ? p.value : "—";
        }
        if (recapPhotos) {
          var f = form.querySelector('[data-mpj-photo-fallback]');
          recapPhotos.textContent = f && f.files && f.files.length ? f.files.length + " photo(s)" : "—";
        }
      });

      /* Package price sync + variant id resolution on submit button */
      var submitBtn = form.querySelector("[data-mpj-submit]");
      var variantInput = form.querySelector("[data-mpj-variant-input]");
      var priceByPackage = { "Vision": "49,90 €", "Projet Complet": "89,90 €", "Grand Extérieur": "129,90 €" };
      var variantMap = {};
      try { variantMap = JSON.parse(form.getAttribute("data-mpj-variant-map") || "{}"); } catch (e) {}

      function syncPackage() {
        var p = form.querySelector('[name="properties[selected_package]"]:checked');
        if (!p) return;
        var shortName = p.getAttribute("data-mpj-package-name");
        if (submitBtn && shortName && priceByPackage[shortName]) {
          submitBtn.textContent = "Valider mon projet — " + priceByPackage[shortName];
        }
        if (variantInput && variantMap[p.value]) {
          variantInput.value = variantMap[p.value];
        }
      }
      form.addEventListener("change", syncPackage);
      syncPackage();

      if (submitBtn) {
        submitBtn.addEventListener("click", function () {
          if (!validateStep(steps[steps.length - 1])) return;
          syncPackage();
          form.submit();
        });
      }

      if (steps.length) show(0);
    });

    /* Native file input fallback preview */
    document.querySelectorAll("[data-mpj-photo-box]").forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      var title = box.querySelector("[data-mpj-photo-title]");
      if (!input) return;
      box.addEventListener("click", function (e) {
        if (e.target !== input) input.click();
      });
      input.addEventListener("change", function () {
        if (input.files && input.files.length && title) {
          title.textContent = input.files.length + " photo(s) sélectionnée(s)";
        }
      });
    });
  })();

  /* ---------------- Sticky mobile CTA ---------------- */
  (function () {
    var bar = document.querySelector("[data-mpj-sticky-cta]");
    if (!bar) return;
    if (document.querySelector("[data-mpj-wizard]")) { bar.style.display = "none"; return; }
    var showAfter = 480;
    window.addEventListener(
      "scroll",
      function () {
        bar.classList.toggle("is-visible", window.scrollY > showAfter);
      },
      { passive: true }
    );
  })();

  /* ---------------- Simple tracking helper ---------------- */
  window.mpjTrack = window.mpjTrack || function (eventName, params) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      }
    } catch (e) {}
  };

  document.querySelectorAll("[data-mpj-track]").forEach(function (el) {
    el.addEventListener("click", function () {
      window.mpjTrack(el.getAttribute("data-mpj-track"), {
        package: el.getAttribute("data-mpj-package") || undefined
      });
    });
  });
}
